import { render, staticRenderFns } from "./patent_data_table.vue?vue&type=template&id=6ec0e1cd"
import script from "./patent_data_table.vue?vue&type=script&lang=js"
export * from "./patent_data_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports